// extracted by mini-css-extract-plugin
var _1 = "actions-MlbLA";
var _2 = "orders-HkcWk";
export { _1 as "actions", _2 as "orders" }
